// @material-ui/core components
import { makeStyles } from "tss-react/mui";
import { Modal } from "@mui/material";
import Link from "next/link.js";

// core components
import Button from "../CustomButtons/Button";
import Image from "next/image.js";

import ForumsModal from "../ForumsModal/ForumsModal";

import styles from "../../styles/jss/nextjs-material-kit/pages/forumsStyle.js";

// local assets
import closeIcon from "../../public/img/forums/icons/closeIcon.png";
import holdupIcon from "../../public/img/forums/icons/holdupIcon.png";

const useStyles = makeStyles()(styles);

const communityGuidelinesUrl = "/community/community-guidelines-3"

export default function ForumsBlockerModal(props) {
    const { classes, cx } = useStyles();

    const generateText = () => {
        if (props.type === "timeout") {
            return <p className={classes.modalText}>You need to wait until tomorrow before posting again.</p>
        } else if (props.type === "language") {
            return <p className={classes.modalText}>Your post did not meet our <Link href={communityGuidelinesUrl}>Community Guidelines</Link>. Please be considerate of others in the community and try again.</p>
        } else {
            return <p className={classes.modalText}>You can't post right now.</p>
        }
    }
    return (
        <ForumsModal
            open={props.open}
            onClose={props.onClose}
            closeButton={true}
            width={classes.width50}
        >
                <div className={classes.modalContent}>
                <Image className={classes.modalIcon} src={holdupIcon} alt={"hold-up-icon"} width={80} height={80} />
                        <h3 className={classes.modalTitle}>Hold up!</h3>
                        {generateText()}
                <Button className={cx(classes.darkButton + " " + classes.mediumButton)} onClick={props.onClose}>Got it</Button>

                </div>
        </ForumsModal>
    )
}

